import React, { useState } from 'react';
import './HelpTooltip.css';

/**
 * HelpTooltip Component
 * A premium, Apple-style interactive information icon with hover and click popover support.
 * 
 * @component HelpTooltip
 * @param {Object} props
 * @param {string} props.text - The help text to display inside the popover.
 * @param {string} [props.position='top'] - Position of the tooltip: 'top', 'bottom', 'left', 'right'.
 */
export default function HelpTooltip({ text, position = 'top' }) {
    const [visible, setVisible] = useState(false);

    return (
        <div className="help-tooltip-container">
            <button
                type="button"
                className="help-tooltip-trigger"
                onMouseEnter={() => setVisible(true)}
                onMouseLeave={() => setVisible(false)}
                onClick={() => setVisible(!visible)}
                aria-label="Information"
            >
                ⓘ
            </button>
            {visible && (
                <div className={`help-tooltip-popover help-tooltip-${position}`}>
                    <div className="help-tooltip-content">
                        {text}
                    </div>
                    <div className="help-tooltip-arrow" />
                </div>
            )}
        </div>
    );
}
